const _version = "3.0.1"
function version() {
    return _version
}
export default version
